import script from "./permissioGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./permissioGroup.vue?vue&type=script&setup=true&lang=js"

import "./permissioGroup.vue?vue&type=style&index=0&id=f8b87194&lang=scss"

const __exports__ = script;

export default __exports__